module.exports = __webpack_public_path__ + "img/logo-etaxoneth.eafaced9.webp";